const { DEVICE_STATUS } = require('../constants/devices/deviceStatuses')

angular
  .module('surfsightApp.controllers')
  .controller('dashcamLiveVideoController', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$mdToast',
    '$mdColors',
    '$localStorage',
    'edgeFactoryV2',
    '$filter',
    '$q',
    function (
      $scope,
      $timeout,
      $interval,
      $http,
      $mdToast,
      $mdColors,
      $localStorage,
      edgeFactoryV2,
      $filter,
      $q
    ) {
      const hlsPlayer = require('../js/single_hls')
      const webrtcPlayer = require('../js/single_webrtc')

      const defaultPlayerType = 'webrtc'
      const dashcamHLSfilename = 'playlist.m3u8'
      const mediaTokenTimeoutInMs = 30 * 60 * 1000 // token is valid for 30 minutes
      let currentPlayerType = null

      const {
        dashcamStream: { serialNumber, streamId }
      } = $scope
      const videoElementId = `${serialNumber}-${streamId}`

      let currentPlayerInstance = null
      let changePlayerTypeTimeout = null
      let changePlayerTypeHttpRequstTimeout = null
      $scope.dashcamStreamDisplay = {
        serialNumber,
        cameraName: $scope.dashcamStream.cameraName || serialNumber,
        streamId: streamId,
        streamName: window.getCameraNameByStreamId(
          $filter('translate'),
          edgeFactoryV2.list.find(e => e.imei === serialNumber),
          streamId
        )
      }
      $scope.videoElementId = videoElementId
      $scope.playerStatus = {
        playPause: true,
        maximized: false
      }
      $scope.hoveringVideoElement = false
      $scope.toggleVideoElement = true

      let videoSource = null
      const playLiveVideo = function () {
        if (currentPlayerType === 'webrtc') {
          currentPlayerInstance = webrtcPlayer.player({
            videoElementId,
            videoSource
          })
        } else if (currentPlayerType === 'hls') {
          currentPlayerInstance = hlsPlayer.player({
            videoElementId,
            videoSource
          })
        }
      }
      const stopLiveVideo = function () {
        $scope.resetChangePlayerTypeTimeout()
        changePlayerTypeHttpRequstTimeout &&
          changePlayerTypeHttpRequstTimeout.resolve() &&
          (changePlayerTypeHttpRequstTimeout = null)
        if (currentPlayerInstance) {
          currentPlayerInstance.stop()
          currentPlayerInstance = null
        }
        $timeout(function () {
          $scope.toggleVideoElement = false
          $timeout(function () {
            $scope.toggleVideoElement = true
          })
        })
      }
      const goFullScreen = function () {
        try {
          const elem = document.getElementById(`remoteVideo-${videoElementId}`)
          if (elem.requestFullscreen) {
            elem.requestFullscreen()
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen()
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen()
          } else if (elem.webkitEnterFullScreen != undefined) {
            elem.webkitEnterFullScreen() // Safari
          }
        } catch (e) {
          console.error(e)
        }
      }

      $scope.resetChangePlayerTypeTimeout = () => {
        if (changePlayerTypeTimeout) {
          $timeout.cancel(changePlayerTypeTimeout)
          changePlayerTypeTimeout = null
        }
      }

      $scope.setChangePlayerTypeTimeout = timeoutInMs => {
        $scope.resetChangePlayerTypeTimeout()
        changePlayerTypeTimeout = $timeout(() => {
          $scope.changePlayerType(currentPlayerType)
        }, timeoutInMs)
      }

      $scope.changePlayerType = async function (
        playerType = defaultPlayerType
      ) {
        const device = edgeFactoryV2.list.find(
          edge => edge.imei === serialNumber
        )
        if (device && device.status === DEVICE_STATUS.STANDBY) {
          return false
        }

        $scope.resetChangePlayerTypeTimeout()
        if (!$scope.playerStatus.playPause) {
          return false
        }
        stopLiveVideo()
        changePlayerTypeHttpRequstTimeout = $q.defer()
        currentPlayerType = playerType
        $scope.currentPlayerType = currentPlayerType

        try {
          const {
            address,
            mediaToken
          } = await edgeFactoryV2.prepareDeviceMediaStreaming(
            serialNumber,
            changePlayerTypeHttpRequstTimeout.promise
          )
          $scope.setChangePlayerTypeTimeout(mediaTokenTimeoutInMs)
          if (playerType === defaultPlayerType) {
            videoSource = `https://${address}/${defaultPlayerType}/#PEERID#/${serialNumber}/${streamId}/${mediaToken}`
          } else if (playerType === 'hls') {
            videoSource = `https://${address}/${serialNumber}/${streamId}/${mediaToken}/${dashcamHLSfilename}`
          }
          playLiveVideo()
        } catch ({ xhrStatus }) {
          if (xhrStatus !== 'abort') {
            $scope.setChangePlayerTypeTimeout(1500)
          }
        } finally {
          changePlayerTypeHttpRequstTimeout = null
        }
      }
      $scope.changePlayerType()
      $scope.togglePlayerType = function () {
        $scope.displayOptions.showPlayerTypeOptions = false
        $timeout(function () {
          currentPlayerType = $scope.displayOptions.currentPlayerType
          $scope.playerStatus.playPause = true
          $scope.changePlayerType(currentPlayerType)
        })
      }
      $scope.showPlayerTypeOptions = function () {
        $scope.displayOptions.showPlayerTypeOptions = !$scope.displayOptions
          .showPlayerTypeOptions
      }

      $scope.$watch(
        () => $scope.playerStatus.playPause,
        newValue => {
          const liveVideoTimeoutSeconds =
            ($localStorage.userOrganization &&
              $localStorage.userOrganization.liveVideoTimeoutSeconds) ||
            30
          if (liveVideoTimeoutSeconds > 0) {
            if (!newValue && $scope.pauseInterval) {
              $interval.cancel($scope.pauseInterval)
            }
            if (newValue) {
              $scope.pauseInterval = $interval(() => {
                console.warn(
                  'Terminating video due to timeout after %d seconds',
                  liveVideoTimeoutSeconds
                )
                $scope.playPause()
              }, liveVideoTimeoutSeconds * 1000)
            }
          }
        }
      )
      $scope.playPause = function () {
        const currentPlayerStatus = $scope.playerStatus.playPause
        $scope.playerStatus.playPause = !$scope.playerStatus.playPause
        if (currentPlayerStatus) {
          stopLiveVideo()
        } else {
          $scope.changePlayerType(currentPlayerType)
        }
      }
      $scope.fullScreen = function () {
        goFullScreen()
      }
      $scope.shareDashcamLiveVideo = e => {
        $scope.callback({
          type: 'shareDashcamLiveVideo',
          dashcamStream: $scope.dashcamStream,
          data: {}
        })
      }
      $scope.closeDashcamLiveVideo = e => {
        $scope.callback({
          type: 'closeDashcamLiveVideo',
          dashcamStream: $scope.dashcamStream,
          data: {}
        })
      }
      $scope.displayOptions = {
        playerType: true,
        showPlayerTypeOptions: false,
        currentPlayerType: defaultPlayerType,
        fullScreen: true,
        playPause: true,
        share: false,
        closeVideo: true
      }
      $scope.$on('restartVideo', function (e, data) {
        if (data.videoElementId === videoElementId) {
          stopLiveVideo()
          $scope.changePlayerType(currentPlayerType)
        }
      })
      $scope.$on('$destroy', function () {
        $scope.pauseInterval && $interval.cancel($scope.pauseInterval)
        $scope.playerStatus.playPause = false
        stopLiveVideo()
      })
    }
  ])
